<div class="pagecontent">
    <h1 class="header-content">Enter Trip Details</h1>
    <span class="section-header">Trip Consumer Details</span>
    <div class="trip-consumer-row">
        <p class="custom-width">
            <strong>Consumer Name: </strong>
            {{tripRequest.get('firstName')?.value}}, {{tripRequest.get('lastName')?.value}}
        </p>
        <p>
            <strong>RID: </strong>
            {{tripRequest.get('recipientId')?.value}}
        </p>
    </div>
    <div class="trip-consumer-row">
        <p class="custom-width">
            <strong>Trip Status: </strong>
            {{tripStatus}}
        </p>
        <p>
            <strong>Confirmation No: </strong>
            {{tripConfirmationNo}}
        </p>
    </div>
    <div formGroupName="tripRequest">
        <div class="trip-type-container">
            <span class="section-header">Trip Type</span>
            <span class="sub-header">What type of trip was it?</span>
            <div class="radio-container">
                <fieldset class="radio-fieldset" aria-label="Select reimbursement request type">
                    <mat-radio-group class="horizontal-radio-group" formControlName="tripType" 
                        (change)="onTripTypeChange($event)" aria-label="Select reimbursement request type">
                        <mat-radio-button class="pre-trip-margin" value="Pre" aria-label="Select pre trip reimbursement request">
                            Pre-Trip Authorization
                        </mat-radio-button>
                        @if(!preTripFlag) {
                            <mat-radio-button value="Post" aria-label="Select Post trip reimbursement request">
                                Post-Trip Reimbursement Request
                            </mat-radio-button>
                        }
                    </mat-radio-group>
                </fieldset>
            </div>
        </div>
        <div class="trip-appointments">
            <div class="appointment-header">
                <span class="sub-header">When did the trip take place?</span>
            </div>
            @for (date of appointmentDatesFr.controls; track date; let i = $index) {
                <div formArrayName="tripAppointments">   
                    <div [formGroupName] ="i">
                        <div class="appointment-date-row" >
                            <div class="form-field">
                                <label [for]="'appointmentDate'+i"> Appointment Date <span class="star">*</span></label>
                                <mat-form-field>
                                    <input  [id]="'appointmentDate'+i" matInput [matDatepicker]="datepicker" formControlName="appointmentDate"
                                        placeholder="Choose a date" [errorStateMatcher]="appointmentMatcher"/>
                                    <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                                    <mat-datepicker #datepicker></mat-datepicker>
                                    @if (hasError(`tripAppointments.${i}.appointmentDate`, 'invalid')) {
                                        <mat-error>Invalid Date.</mat-error>
                                    }@else if (hasError(`tripAppointments.${i}.appointmentDate`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }@else if(hasError(`tripAppointments.${i}.appointmentDate`, 'pastDateRequired')) {
                                        <mat-error>Date should not be future date.</mat-error>
                                    }@else if(hasError(`tripAppointments.${i}.appointmentDate`, 'futureDateRequired')) {
                                        <mat-error>Date should not be past date.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="form-field">
                                <label [for]="'appointmentDateTime'+i"> Appointment Time <span class="star">*</span> </label>
                                <mat-form-field>
                                    <input [id]="'appointmentDateTime'+i" matInput [matTimepicker]="timepicker" formControlName="appointmentTime"
                                    placeholder="Choose a time" [errorStateMatcher]="appointmentMatcher" />
                                    <mat-timepicker-toggle matIconSuffix [for]="timepicker"></mat-timepicker-toggle>
                                    <mat-timepicker #timepicker></mat-timepicker>
                                    @if (hasError(`tripAppointments.${i}.appointmentTime`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                    @if (hasError(`tripAppointments.${i}`, 'futureTimeRequired')) {
                                        <mat-error>Invalid Time.</mat-error>
                                    }
                                    @if (hasError(`tripAppointments.${i}`, 'pastTimeRequired')) {
                                        <mat-error>Invalid Time.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="remove-appointment">
                                <a (click)="removeAppointment(i)" tabindex="0" role="button" (keydown.enter)="removeAppointment(i)">
                                <span>
                                    <mat-icon aria-hidden="false" aria-label="Remove Appointment">remove_circle_outline</mat-icon>
                                </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div class="add-appointment">
                <a (click)="addAppointment()" tabindex="0" role="button" (keydown.enter)="addAppointment()">
                    <span>Add Appointment</span>
                    <span>
                        <mat-icon aria-hidden="false" aria-label="Add action icon">add_circle_outline</mat-icon>
                    </span>
                </a>
            </div>
        </div>
        @if(tripRequest.get("tripType")?.value == 'Post' ) {
            <div class="driver-content">
                <span class="section-header">Driver Information</span>
                @if (appointmentDatesFr.length > 1 || !tripRequest.get('isSameDriver')?.value) {
                    <div class="driver-option-section">
                        <div class="form-field">
                            <fieldset class="radio-fieldset">
                                <legend id="isSameDriverLabel">Is the driver same for all appointments</legend>
                                <mat-radio-group formControlName="isSameDriver" aria-labelledby="isSameDriverLabel">
                                    <mat-radio-button [value]='true' aria-label="Yes, the same driver is used for all appointments">Yes</mat-radio-button>
                                    <mat-radio-button [value]='false' aria-label="No, different drivers are used for appointments">No</mat-radio-button>
                                </mat-radio-group>
                            </fieldset>
                        </div>
                    </div>
                }   
                <span class="sub-header">Who was driving the vehicle?</span>
                @if (tripRequest.get('isSameDriver')?.value) {        
                    @if (!tripRequest.get('driverMannualEntry')?.value) {
                        <div class="driver-row control-width">
                            <div class="driver-form-field">
                                <mat-label>Select Driver Name <span class="star">*</span></mat-label>
                                <mat-form-field>
                                    <mat-select formControlName="driverId" placeholder="Select Driver" [errorStateMatcher]="matcher" (selectionChange)="driverSelectionChange($event)">
                                    @for (driver of driverList$ | async; track driver.id) {
                                        <mat-option [value]="driver.id">{{ driver.fullName }}</mat-option>
                                    }
                                    </mat-select>
                                    @if (hasError('driverId', 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                                <span class="span-manual">Don't see your driver? 
                                    <a (click)="onEnterDriverManual($event, -1)" 
                                        tabindex="0" role="button" 
                                        (keydown.enter)="onEnterDriverManual($event, -1)">Enter the driver information</a>
                                </span>
                            </div>
                        </div>
                    }
                    @else {
                        <div class="driver-row">
                            <div class="driver-form-field">
                                <label for="driverFirstName" >First Name <span class="star">*</span></label>
                                <mat-form-field appearance="outline">
                                    <input id="driverFirstName" formControlName="driverFirstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher" />
                                    @if (hasError('driverFirstName', 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="driver-form-field">
                                <label for="driverLastName">Last Name <span class="star">*</span></label>
                                <mat-form-field appearance="outline">
                                    <input id="driverFirstName" formControlName="driverLastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher" />
                                    @if (hasError('driverLastName', 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="driver-save">
                            <span class="span-list">Select Driver from 
                                <a (click)="onEnterDriverfromList($event, -1)" tabindex="0" role="button" 
                                        (keydown.enter)="onEnterDriverfromList($event, -1)">List</a>
                            </span>
                            <mat-checkbox formControlName="saveDriverIntoProfile">Save Driver to Profile</mat-checkbox>
                        </div>
                    }
                }
                @if(!tripRequest.get('isSameDriver')?.value) {
                    @for (date of appointmentDatesFr.controls; track date; let i = $index) {
                        <div formArrayName="tripAppointments">   
                            <div class ="appointment-content" [formGroupName]="i" >
                                <span class="appointment-date">Appointment: {{date.get('appointmentDate')?.value | date: 'MM/dd/yyyy' }} at {{ date.get('appointmentDate')?.value | date: 'shortTime'}}</span>
                                @if (date.get('driverMannualEntry')?.value === false) {
                                    <div class="driver-row control-width">
                                        <div class="driver-form-field">
                                            <label [for]="'driverId'+i">Select Driver Name</label>
                                            <mat-form-field>
                                                <mat-select [id]="'driverId'+i" formControlName="driverId" placeholder="Select Driver" 
                                                    [errorStateMatcher]="matcher" (selectionChange)="appointmentDriverSelectionChange($event, i)">
                                                @for (driver of driverList$ | async; track driver.id) {
                                                    <mat-option [value]="driver.id">{{ driver.fullName }}</mat-option>
                                                }
                                                </mat-select>
                                                @if (hasError(`tripAppointments.${i}.driverId`, 'required')) {
                                                    <mat-error>This field is required.</mat-error>
                                                }
                                            </mat-form-field>
                                            <span class="span-manual">Don't see your driver? 
                                                <a (click)="onEnterDriverManual($event,i)" tabindex="0" role="button" 
                                                (keydown.enter)="onEnterDriverManual($event,i)" >Enter the driver information</a>
                                            </span>
                                        </div>
                                    </div>
                                }
                                @else {
                                    <div class="driver-row">
                                        <div class="driver-form-field">
                                            <label [for]="'driverFirstName'+i">First Name <span class="star">*</span></label>
                                            <mat-form-field appearance="outline">
                                                <input [id]="'driverFirstName'+i" formControlName="driverFirstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher"/>
                                                @if (hasError(`tripAppointments.${i}.driverFirstName`, 'required')) {
                                                    <mat-error>This field is required.</mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                        <div class="driver-form-field">
                                            <label [for]="'driverLastName'+i">Last Name <span class="star">*</span></label>
                                            <mat-form-field appearance="outline">
                                                <input [id]="'driverLastName'+i" formControlName="driverLastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher" />
                                                @if (hasError(`tripAppointments.${i}.driverLastName`, 'required')) {
                                                    <mat-error>This field is required.</mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="driver-save">
                                        <span class="span-list">Select Driver from 
                                            <a (click)="onEnterDriverfromList($event,i)" tabindex="0" role="button" 
                                            (keydown.enter) ="onEnterDriverfromList($event,i)">List</a></span>
                                        <mat-checkbox formControlName="saveDriverIntoProfile">Save Driver to Profile</mat-checkbox>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                } 
            </div>
            <div class="passenger-content">
                <span class="section-header">Passenger Information</span>
                <div class="passenger-option-section">
                    <div class="form-field">
                        <fieldset class="radio-fieldset">
                        <legend id="anotherMedicaidConsumer">Are there any other medicaid consumers traveling to the appointment?</legend>
                        <mat-radio-group formControlName="anotherMedicaidConsumer" (change)="onMedicaidConsumerChange($event)" aria-labelledby="anotherMedicaidConsumer">
                            <mat-radio-button [value]='true' aria-label="Yes, additional medicaid consumer traveling with this appointment">Yes</mat-radio-button>
                            <mat-radio-button [value]='false' aria-label="No, additional medicaid consumer traveling with this appointment">No</mat-radio-button>
                        </mat-radio-group>
                    </fieldset>
                    </div>
                </div>
                @if(tripRequest.get("anotherMedicaidConsumer")?.value && appointmentDatesFr.length == 1) {
                    @for (date of tripPassengerFr.controls; track date; let k = $index) {
                        <div  formArrayName="tripPassengers"> 
                            <div [formGroupName] = "k" >
                                <div class="passenger-row">
                                    <div class="passenger-form-field">
                                        <label [for]="'passengerFirstName_trip'+k" >First Name <span class="star">*</span></label>
                                        <mat-form-field appearance="outline">
                                            <input [id]="'passengerFirstName_trip'+k" formControlName="firstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher" />
                                            @if (hasError(`tripPassengers.${k}.firstName`, 'required')) {
                                                <mat-error>This field is required.</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="passenger-form-field">
                                        <label [for]="'passengerLastName_trip'+k">Last Name <span class="star">*</span></label>
                                        <mat-form-field appearance="outline">
                                            <input [id]="'passengerLastName_trip'+k" formControlName="lastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher"/>
                                            @if (hasError(`tripPassengers.${k}.lastName`, 'required')) {
                                                <mat-error>This field is required.</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="remove-passenger">
                                        <a (click)="removeTripPassenger(k)" tabindex="0" role="button" 
                                        (keydown.enter)="removeTripPassenger(k)">
                                            <span>
                                                <mat-icon aria-hidden="false" aria-label="Remove Passenger">remove_circle_outline</mat-icon>
                                            </span>
                                        </a>
                                    </div>                               
                                </div>
                            </div>
                        </div>                        
                    }
                    <div class="add-passenger">
                        <a (click)="addTripPassenger()" tabindex="0" role="button" (keydown.enter)="addTripPassenger()">
                            <span>Add Additional Passenger</span>
                            <span >
                                <mat-icon class="add-passenger-icon" aria-hidden="false" aria-label="Add action icon">add_circle_outline</mat-icon>
                            </span>
                        </a>
                    </div>
                }
                @if (appointmentDatesFr.length > 1 && tripRequest.get('anotherMedicaidConsumer')?.value) {
                    <div class="passenger-row">
                        <div class="passenger-form-field">
                            <fieldset class="radio-fieldset">
                                <legend id="samePassenger">Is the passenger same for all appointments?</legend>
                                <mat-radio-group formControlName="samePassenger" aria-labelledby="samePassenger" (change)="onSamePassengerChange($event)">
                                    <mat-radio-button [value]='true' aria-label="Yes, the same passenger is used for all appointments">Yes</mat-radio-button>
                                    <mat-radio-button [value]='false' aria-label="No, different passenger are used for appointments">No</mat-radio-button>
                                </mat-radio-group>
                        </fieldset>
                        </div>
                    </div>
                    @if (!tripRequest.get('samePassenger')?.value) {
                        @for (date of appointmentDatesFr.controls; track date; let i = $index) {
                            <div  formArrayName="tripAppointments">   
                                <div  [formGroupName]="i" >
                                    @if(!tripRequest.get("samePassenger")?.value) {
                                        <div class="trip-appointment-date-container">
                                            <span class="appointment-date">Appointment: {{date.get('appointmentDate')?.value | date: 'MM/dd/yyyy' }} 
                                                    at {{ date.get('appointmentDate')?.value | date: 'shortTime'}}</span>
                                        </div>
                                        @for (address of getPassenger(i).controls; track address; let j = $index) {
                                            <div formArrayName="appointmentPassengers">   
                                                <div  [formGroupName]="j" >
                                                    <div class="passenger-row">
                                                        <div class="passenger-form-field">
                                                            <label [for]="'firstName'+i+'-'+j" >First Name <span class="star">*</span></label>
                                                            <mat-form-field appearance="outline">
                                                                <input [id]="'firstName'+i+'-'+j" formControlName="firstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher" />
                                                                @if (hasError(`tripAppointments.${i}.appointmentPassengers.${j}.firstName`, 'required')) {
                                                                    <mat-error>This field is required.</mat-error>
                                                                }
                                                            </mat-form-field>
                                                        </div>
                                                        <div class="passenger-form-field">
                                                            <label [for]="'lastName'+i+'-'+j">Last Name <span class="star">*</span></label>
                                                            <mat-form-field appearance="outline">
                                                                <input [id]="'lastName'+i+'-'+j" formControlName="lastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher" />
                                                                @if (hasError(`tripAppointments.${i}.appointmentPassengers.${j}.lastName`, 'required')) {
                                                                    <mat-error>This field is required.</mat-error>
                                                                }
                                                            </mat-form-field>
                                                        </div>
                                                        <div class="remove-passenger">
                                                            <a (click)="removePassenger(i, j)" tabindex="0" 
                                                            role="button" (keydown.enter) = "removePassenger(i, j)">
                                                            <span>
                                                                <mat-icon aria-hidden="false" aria-label="Remove Passenger">remove_circle_outline</mat-icon>
                                                            </span>
                                                            </a>
                                                        </div>                               
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    }
                                </div>
                            </div>
                            @if(!tripRequest.get("samePassenger")?.value) {
                                <div class="add-passenger">
                                    <a (click)="addPassenger(i)" tabindex="0" role="button" (keydown.enter)="addPassenger(i)">
                                        <span>Add Additional Passenger</span>
                                        <span >
                                            <mat-icon class="add-passenger-icon" aria-hidden="false" aria-label="Add action icon">add_circle_outline</mat-icon>
                                        </span>
                                    </a>
                                </div>
                            }
                        } 
                    }
                    @else {
                        @for (date of tripPassengerFr.controls; track date; let k = $index) {
                            <div  formArrayName="tripPassengers"> 
                                <div [formGroupName] = "k" >
                                    <div class="passenger-row">
                                        <div class="passenger-form-field">
                                            <label [for]="'passengerFirstName_trip'+k" >First Name <span class="star">*</span></label>
                                            <mat-form-field appearance="outline">
                                                <input [id]="'passengerFirstName_trip'+k" formControlName="firstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher" />
                                                @if (hasError(`tripPassengers.${k}.firstName`, 'required')) {
                                                    <mat-error>This field is required.</mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                        <div class="passenger-form-field">
                                            <label [for]="'passengerLastName_trip'+k">Last Name <span class="star">*</span></label>
                                            <mat-form-field appearance="outline">
                                                <input [id]="'passengerLastName_trip'+k" formControlName="lastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher"/>
                                                @if (hasError(`tripPassengers.${k}.lastName`, 'required')) {
                                                    <mat-error>This field is required.</mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                        <div class="remove-passenger">
                                            <a (click)="removeTripPassenger(k)" tabindex="0" role="button" 
                                                (keydown.enter)="removeTripPassenger(k)">
                                                <span>
                                                    <mat-icon aria-hidden="false" aria-label="Remove Passenger">remove_circle_outline</mat-icon>
                                                </span>
                                            </a>
                                        </div>                               
                                    </div>
                                </div>
                            </div>                        
                        }
                        <div class="add-passenger">
                            <a (click)="addTripPassenger()" tabindex="0" role="button" (keydown.enter)="addTripPassenger()">
                                <span>Add Additional Passenger</span>
                                <span >
                                    <mat-icon class="add-passenger-icon" aria-hidden="false" aria-label="Add action icon">add_circle_outline</mat-icon>
                                </span>
                            </a>
                        </div>
                    }
                }              
            </div>
        }
        <div class="trip-location-content">
            <span class="section-header">Trip Details</span>
            <div class="trip-location-adjusted-width-row">
                <div class="address-form-field appointment-type-width">
                    <mat-label for="appointmentTypeId">Type Of MA Appointment</mat-label> 
                    <mat-form-field>                              
                        <mat-select formControlName="appointmentTypeId" placeholder="Select MA Appointment" (selectionChange)="onAppointmentTypeChange($event)" 
                            [errorStateMatcher]="matcher">
                            @for (appType of appointmentTypesList$ | async; track appType.id;) {
                                <mat-option [value]="appType.id">{{ appType.appointmentTypeName }}</mat-option>
                            }
                        </mat-select>
                        @if (hasError('appointmentTypeId', 'required')) {
                            <mat-error>This field is required.</mat-error>
                        }
                    </mat-form-field>
                </div>
                @if(showAppointmentType) {
                    <div class="address-form-field appointment-type-width">
                        <label for="appointmentType">MA Appointment Type</label>
                        <mat-form-field appearance="outline">
                            <input formControlName="appointmentType" matInput placeholder="Enter Appointment Type" [errorStateMatcher]="matcher" />
                            @if (hasError('appointmentType', 'required')) {
                                <mat-error>This field is required.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                }

            </div>
            @for (address of tripAddressFr.controls; track address; let i = $index) {
                <div formArrayName="tripAddresses">   
                    <div  [formGroupName]="i" >
                        @if (address.get('locationMannualEntry')?.value === true) {
                            <div class="trip-location-row">                                 
                                <div class="address-form-field">
                                    <mat-label for="addressCategoryId">Address Category </mat-label> 
                                    <mat-form-field>
                                        <mat-select formControlName="addressCategoryId" placeholder="Select Category" [errorStateMatcher]="matcher">
                                        @for (category of addressCategoryList$ | async; track category.categoryId) {
                                            <mat-option [value]="category.categoryId.toString()">{{ category.categoryName }}</mat-option>
                                        }
                                        </mat-select>
                                        @if (hasError(`tripAddresses.${i}.addressCategoryId`, 'required')) {
                                            <mat-error>This field is required.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                                @if(IsOtherCategory(address.get('addressCategoryId')?.value)) {
                                    <div class="address-form-field">
                                        <label [for]="'otherCategoryType' + i">Other Category Type</label>
                                        <mat-form-field appearance="outline">
                                            <input [id]= "'otherCategoryType' + i" formControlName="otherCategoryType" matInput placeholder="Enter otherCategoryType" [errorStateMatcher]="matcher" />
                                            @if (hasError(`tripAddresses.${i}.otherCategoryType`, 'required')) {
                                                <mat-error>This field is required.</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                }
                                <div class="address-form-field">
                                    <label [for]="'providerOrNickName' + i">Provider Name/ Nickname</label>
                                    <mat-form-field appearance="outline">
                                        <input [id]= "'providerOrNickName' + i" formControlName="providerOrNickName" matInput placeholder="Enter Provider/ Nickname" [errorStateMatcher]="matcher" />
                                        @if (hasError(`tripAddresses.${i}.providerOrNickName`, 'required')) {
                                            <mat-error>This field is required.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                                <div class="address-form-field">
                                    <label [for]="'address' + i">{{getAddressCaption(i)}}</label>
                                    <mat-form-field appearance="outline">
                                        <input [id]="'address' + i" class="address-width" formControlName="address" matInput placeholder="Search Address" 
                                        [errorStateMatcher]="matcher" [matAutocomplete]="auto" (input)="onAddressEntered(i)"/>
                                        <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="onAddressSelected($event, i)">
                                            @for (ads of filteredAddress$[i] | async; track $index) {
                                            <mat-option [value]="ads">
                                                {{ ads }}
                                            </mat-option>
                                            }
                                        </mat-autocomplete>
                                        @if (hasError(`tripAddresses.${i}.address`, 'required')) {
                                            <mat-error>This field is required.</mat-error>
                                        }
                                        @if (hasError(`tripAddresses.${i}.address`, 'inValidStateCode')) {
                                            <mat-error>Invalid State.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </div>
                            <div [ngClass]="getSubRowClass(i)">
                                @if (tripAddressFr.controls.length === i+1 && tripRequest.get('showRoundTrip')?.value === true) {
                                    <mat-checkbox [formControl]="getIsRoundTripControl()" (change)="onRoundTripChange($event)">Round Trip</mat-checkbox>                                    
                                }
                                <div class="sub-row-container">
                                    <span>Select from provider 
                                        <a (click)="onEnterExistingLocation(address.get('locationMannualEntry'))" 
                                        tabindex="0" role="button" 
                                        (keydown.enter)="onEnterExistingLocation(address.get('locationMannualEntry'))"> List</a>
                                    </span> 
                                    @if(i !== 0 && i !== tripAddressFr.controls.length -1 ) {
                                        <span>Remove 
                                            <a (click)="removeStopping(i)" tabindex="0" role="button" 
                                                (keydown.enter)="removeStopping(i)">Stop
                                            </a>
                                        </span>
                                    }
                                    <mat-checkbox formControlName="saveAddress">Save Address to Profile</mat-checkbox> 
                                </div>                              
                            </div>
                            @if (i !== 0) {
                                <div class="map-container">
                                    <span>Pick <a (click)="onSelectAddressfromMap(i)"
                                        tabindex="0" role="button" (keydown.enter)="onSelectAddressfromMap(i)">Address</a> from map
                                    </span>                            
                                </div>
                            }
                        }
                        @else {
                            <div class="trip-location-row"> 
                                <div class="address-form-field">
                                    <mat-label for="addressCategoryId">Address Category</mat-label>
                                    <mat-form-field>
                                        <mat-select  placeholder="Select Category" formControlName="addressCategoryId" 
                                            (selectionChange)="onAddressCategoryChange($event, i)" [errorStateMatcher]="matcher">
                                            @for (category of recipientaddressCategories$ | async; track category.categoryId) {
                                                <mat-option [value]="category.categoryId">{{ category.categoryName }}</mat-option>
                                            }
                                        </mat-select>
                                        @if (hasError(`tripAddresses.${i}.addressCategoryId`, 'required')) {
                                            <mat-error>This field is required.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>                                
                                <div class="address-form-field">
                                    <mat-label for="selectedAddress">Provider Name/ Nickname</mat-label>
                                    <mat-form-field>
                                        <mat-select placeholder="Select Provider Address" formControlName="selectedAddress" 
                                                    (selectionChange)="onProviderAddressChange($event, i)">
                                        @for (provider of providerAddress$[i] | async; track provider.providerWithAddress; let isLast = $last) {
                                            <mat-option [value]="provider.address">
                                                {{ provider.providerWithAddress }} <br/>
                                                @if(!isLast) {
                                                    <hr style="height: 2px; background-color: #adaaaa; border: none;">
                                                }
                                            </mat-option>
                                        }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="address-form-field">
                                    <label [for]="'address' + i">{{getAddressCaption(i)}}</label>
                                    <mat-form-field appearance="outline">
                                        <input [id]= "'address' + i" formControlName="address" matInput placeholder="Search Address" [errorStateMatcher]="matcher" [matAutocomplete]="auto" (input)="onAddressEntered(i)" [readonly]="address.get('addressCategoryId')?.value === '6'" />
                                        <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="onAddressSelected($event, i)" >
                                            @for (ads of filteredAddress$[i] | async; track $index;) {
                                                <mat-option [value]="ads">{{ ads }}</mat-option>
                                            }
                                        </mat-autocomplete>
                                        @if (hasError(`tripAddresses.${i}.address`, 'required')) {
                                            <mat-error>This field is required.</mat-error>
                                        }
                                        @if (hasError(`tripAddresses.${i}.address`, 'inValidStateCode')) {
                                            <mat-error>Invalid State.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </div>
                            <div [ngClass]="getSubRowClass(i)">
                                @if (tripAddressFr.controls.length === i+1 && tripRequest.get('showRoundTrip')?.value === true ) {
                                    <mat-checkbox [formControl]="getIsRoundTripControl()" (change)="onRoundTripChange($event)">Round Trip</mat-checkbox>                                   
                                }  
                                <div class="sub-row-container">  
                                    @if(i !== 0 && i !== tripAddressFr.controls.length -1 ) {
                                        <span>Remove 
                                            <a (click)="removeStopping(i)" tabindex="0" role="button" 
                                            (keydown.enter)="removeStopping(i)">Stop</a>
                                        </span>
                                    }                                 
                                    <span>Don't find an address? 
                                        <a (click)="onEnterLocationManual(address.get('locationMannualEntry'))"
                                            tabindex="0" role="button" 
                                            (keydown.enter)="onEnterLocationManual(address.get('locationMannualEntry'))">
                                            Enter location information
                                        </a>
                                    </span> 
                                    @if (address.get('addressCategoryId')?.value !== homeAddressCategory) {
                                        <mat-checkbox formControlName="saveAddress">Save Address to Profile</mat-checkbox> 
                                    }                                                                                                 
                                </div>
                            </div>
                            @if (i !== 0) {
                                <div class="map-container">
                                    <span>Pick <a (click)="onSelectAddressfromMap(i)" 
                                            tabindex="0" role="button" (keydown.enter)="onSelectAddressfromMap(i)">Address
                                        </a> from map
                                    </span>                      
                                </div>
                            }
                            
                        }
                    </div>
                </div>
            } 
            <div class="add-stop-row">
                @if (tripRequest.get('showAdditionalStop')?.value === true) {
                    <button class="add-stop" type="button" matInput  mat-button (click)="addAdditionalStop()" >Add Additional Stop</button>
                }

            </div> 
            
        </div>
        @if(tripRequest.get("tripType")?.value == 'Post' ) {
            <div class="trip-document-content">
                <span class="section-header">Document Upload</span>
                @for (date of appointmentDatesFr.controls; track date; let i = $index) {
                    <div formArrayName="tripAppointments">   
                        <div  [formGroupName]="i" >
                            <div class="document-date-container">
                                <span class="span-font-weight">Appointment: {{date.get('appointmentDate')?.value | date: 'MM/dd/yyyy' }} 
                                        at {{ date.get('appointmentDate')?.value | date: 'shortTime'}}</span>
                            </div>
                            <div class="expense-row">
                                @for (expense of getAppointmentExpense(i).controls; track expense; let j = $index) {
                                <div formArrayName="tripExpenses">   
                                    <div  [formGroupName]="j" >
                                        <div class="document-form-field">
                                            <label [for]="'expenseAmount'+i+'-'+j">
                                                {{expense.get('expenseType')?.value === 'Toll' ? 'Toll Expenses' : 'Parking Expenses'}}</label>
                                            <mat-form-field appearance="outline">
                                                <input [id]="'expenseAmount'+i+'-'+j" formControlName="expenseAmount" matInput placeholder="Enter Expense Amount" decimalOnly/>
                                            </mat-form-field>
                                        </div>                                                                      
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                <div class="document-options" formGroupName="appointmentVerificationDocuments">
                    <div class="expense-row">
                        <div class="document-form-field">
                            <label for="appointment_file_select">Appointment Verification</label>
                            <mat-form-field appearance="outline">
                                <input id="appointment_file_select" matInput [placeholder]="appointmentFileSelectPlaceHolder" readonly 
                                        formControlName ="appointmentDocument">
                            </mat-form-field>
                        </div>
                        <div class="document-form-field">                    
                            <button class="browse-button" type="button" matInput mat-button (click)="appointmentFileSelect()">
                                <div class="button-icon">
                                    <span>Browse</span>
                                    <mat-icon class="mat-icon-file-upload">file_upload</mat-icon>
                                </div>
                            </button>                
                            <input #appointmentfileUpload
                                type="file" 
                                id="file-upload" 
                                style="display: none;" 
                                multiple 
                                (change)="onFilesSelected($event,'appointment')"
                                accept=".pdf, .txt, image/*, .doc, .docx, .xls, .xlsx, .csv">
                        </div>
                    </div>
                    @if (appVerficationDocumentsDto.length > 0) {
                        <div class="file-row">
                            @for (doc of appVerficationDocumentsDto; track $index) {
                                <div class="file-remove">
                                    <span>{{ doc.fileName }}</span>
                                    <mat-icon color="warn" (click)="removeFile($index, 'appointment')">close</mat-icon>
                                </div>   
                            } 
                        </div>
                    }
                    @if(linkingDocuments.length > 0){
                        <div class="panel-container">
                            <mat-expansion-panel [expanded]="false" #documentsPanel hideToggle class="outer-panel" (opened)="onLinkPanelOpen()">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>Link Existing Verification Documents</mat-panel-title>
                                    <mat-icon>
                                        {{ documentsPanel.expanded ? 'remove' : 'add' }}
                                    </mat-icon>
                                </mat-expansion-panel-header>
                                <div class="table-container">
                                    <table mat-table [dataSource]="dataSource">
                                        <ng-container matColumnDef="confirmationNumber">
                                            <th mat-header-cell *matHeaderCellDef> Confirmation No </th>
                                            <td mat-cell *matCellDef="let element"> {{element.confirmationNumber}} </td>
                                        </ng-container>

                                        <!-- Name Column -->
                                        <ng-container matColumnDef="fileNames">
                                            <th mat-header-cell *matHeaderCellDef> File Names </th>
                                            <td mat-cell *matCellDef="let element"> {{element.fileNames}} </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="onRowDoubleClick(documentsPanel, row)"></tr>
                                    </table>
                                    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[pageSize]" showFirstLastButtons aria-label="Select page of trip requests" [hidePageSize]="true"></mat-paginator>
                                </div>
                            </mat-expansion-panel>
                        </div>
                    }
                </div>
                @if(showTollSection) {
                    <div class="document-options reduced-top-margin" formGroupName="tollDocuments">
                        <div class="expense-row">
                            <div class="document-form-field">
                                <label for="toll_file_select">Toll Receipts</label>
                                <mat-form-field appearance="outline">
                                    <input id="toll_file_select" matInput [placeholder]="tollFileSelectPlaceHolder" readonly
                                        formControlName ="tollDocument">
                                </mat-form-field>
                            </div>
                            <div class="document-form-field">                    
                                <button class="browse-button" type="button" matInput mat-button (click)="tollFileSelect()">
                                    <div class="button-icon">
                                        <span>Browse</span>
                                        <mat-icon class="mat-icon-file-upload">file_upload</mat-icon>
                                    </div>
                                </button>                
                                <input #tollfileUpload
                                    type="file" 
                                    id="file-upload" 
                                    style="display: none;" 
                                    multiple 
                                    (change)="onFilesSelected($event, 'Toll')"
                                    accept=".pdf, .txt, image/*, .doc, .docx, .xls, .xlsx, .csv">
                            </div>
                        </div>
                        @if (tollDocumentsDto.length > 0) {
                            <div class="file-row">
                                @for (doc of tollDocumentsDto; track $index) {
                                    <div class="file-remove">
                                        <span>{{ doc.fileName }}</span>
                                        <mat-icon color="warn" (click)="removeFile($index, 'Toll')">close</mat-icon>
                                    </div>   
                                } 
                            </div>
                        }
                    </div>
                }
                @if(showParkingSection) {
                    <div class="document-options reduced-top-margin" formGroupName="parkingDocuments">
                        <div class="expense-row">
                            <div class="document-form-field">
                                <label for="parking_file_select">Parking Receipts</label>
                                <mat-form-field appearance="outline">
                                    <input id="parking_file_select" matInput [placeholder]="parkingFileSelectPlaceHolder" readonly
                                        formControlName ="parkingDocument">
                                </mat-form-field>
                            </div>
                            <div class="document-form-field">                    
                                <button class="browse-button" type="button" matInput mat-button (click)="parkingFileSelect()">
                                    <div class="button-icon">
                                        <span>Browse</span>
                                        <mat-icon class="mat-icon-file-upload">file_upload</mat-icon>
                                    </div>
                                </button>                
                                <input #parkingfileUpload
                                    type="file" 
                                    id="file-upload" 
                                    style="display: none;" 
                                    multiple 
                                    (change)="onFilesSelected($event, 'Parking')"
                                    accept=".pdf, .txt, image/*, .doc, .docx, .xls, .xlsx, .csv">
                            </div>
                        </div>
                        @if (parkingDocumentsDto.length > 0) {
                            <div class="file-row">
                                @for (doc of parkingDocumentsDto; track $index) {
                                    <div class="file-remove">
                                        <span>{{ doc.fileName }}</span>
                                        <mat-icon color="warn" (click)="removeFile($index, 'Parking')">close</mat-icon>
                                    </div>   
                                } 
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
</div>